export default "__VITE_ASSET__Bnm5NX31__"